import React, { useEffect, useState } from 'react'

type Props = any

const CarouselClient: React.FC<Props> = (props) => {
  const [Carousel, setCarousel] = useState<any>(null)

  useEffect(() => {
    let mounted = true
    try {
      // require at runtime to avoid SSR bundling
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const mod = require('react-multi-carousel')
      if (mounted) setCarousel(() => mod.default)

      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = '/styles/react-multi-carousel.css'
      link.crossOrigin = 'anonymous'
      document.head.appendChild(link)
    }
    catch (err) {
      console.error('Failed to load carousel', err)
    }

    return () => { mounted = false }
  }, [])

  if (!Carousel) return <>{props.children}</>
  const Comp = Carousel
  return <Comp {...props}>{props.children}</Comp>
}

export default CarouselClient
